import { Link } from 'react-router-dom';
import { BrandLogo } from './BrandLogo';

export default function Footer() {
  return (
    <footer className="mt-24 bg-brand-dark text-white">
      <div className="page-shell py-14 grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <BrandLogo payoff inverse className="text-xl mb-5" />
          <p className="text-sm text-slate-300 leading-relaxed max-w-sm">
            Il programma del tuo concorso trasformato in un percorso chiaro: contenuti essenziali, mappe e quiz mirati.
          </p>
        </div>
        <div>
          <p className="text-xs tracking-[0.14em] uppercase text-indigo-200 font-semibold mb-3">Piattaforma</p>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><Link to="/concorsi" className="hover:text-brand transition-colors">Catalogo concorsi</Link></li>
            <li><Link to="/area-personale" className="hover:text-brand transition-colors">La mia libreria</Link></li>
            <li><Link to="/accedi" className="hover:text-brand transition-colors">Accedi</Link></li>
            <li><Link to="/programma-partner" className="hover:text-brand transition-colors">Diventa Partner</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-xs tracking-[0.14em] uppercase text-indigo-200 font-semibold mb-3">Metodo Essentials</p>
          <ul className="space-y-2 text-sm text-slate-300">
            <li>Riassunti sintetici</li>
            <li>Mappe concettuali</li>
            <li>Quiz con spiegazioni</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-slate-400">
        © 2026 ConcorsiEssentials — Contenuti protetti, distribuzione vietata.
      </div>
    </footer>
  );
}
